import { Injectable } from "@angular/core";
import { ITradeDealService } from "../ITradeDealService";
import { TradeDeal } from "../../model/core/TradeDeal";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

export abstract class TradeDealPromiseService implements ITradeDealService {
  public abstract confirmTradeDeal(deal: TradeDeal): Promise<any>;
  public abstract confirmTradeDeals(deals: Array<TradeDeal>): Promise<any>;
  public abstract cancelTradeDeal(deal: TradeDeal): Promise<any>;
  public abstract cancelTradeDeals(deals: Array<TradeDeal>): Promise<any>;
  public abstract addFillComment(deal: TradeDeal, comment: string): Promise<any>;
  public abstract getTradeDeals(dealIds: Array<string>): Promise<Array<TradeDeal>>;
  public abstract getTradeDealDetails(
    dealId: string,
    includeDetails: boolean,
    includeConfirmations: boolean,
  ): Promise<TradeDeal>;
  public abstract adaptTradeDeals(deals: Array<object>): Promise<Array<TradeDeal>>;
}
